module.exports = __webpack_public_path__ + "img/g1.25600b3c.png";